export default __webpack_public_path__ + "static/media/imageCategory2.8b40bf94.png";